import { MonoTypeOperatorFunction } from 'rxjs';
import { applyErrorHandler } from './apply-error-handler';
import { catchAndRethrow } from './catch-and-rethrow';
import { HandleErrorsGlobalRecord } from './handle-errors-global-record';
import { selectErrorHandler } from './select-error-handler';

export const handleErrors = <T>(globalHandlers: HandleErrorsGlobalRecord, handlers: Record<string, unknown> = {}): MonoTypeOperatorFunction<T> =>
  catchAndRethrow((err: unknown) => {
    const handler = selectErrorHandler({ ...globalHandlers, ...handlers }, err, true);
    return applyErrorHandler(handler);
  });
